import { router } from '@/Router';
import { getIsMobile } from '@/Utility/hooks';
import type { ZnglyVideo } from '@/graphql/types';
import { useAppStore } from '@/inertia/AppStore';

export const SIDEBAR_LIST_ITEM_PREFIX = 'sli-';
export const getSidebarListDomItem = (id: string): HTMLDivElement | null => {
  const sidebar = document.querySelector('.SideBar .ListWrapper .List');
  if (!sidebar) return null;
  const item = sidebar.querySelector(`.${SIDEBAR_LIST_ITEM_PREFIX}${id.replaceAll('=', '')}`) as HTMLDivElement;
  return item ?? null;
};

export const onSelectPlayerNode = (node: ZnglyVideo, idx: number) => {
  const isMobile = getIsMobile();
  const { setPlayerNode, setBarView, playerNode, isAppPreview } = useAppStore.getState();

  if (isAppPreview) {
    setPlayerNode(node);
    setBarView('list');
    return;
  }

  if (!node?.link) {
    setPlayerNode(null);
    return;
  }

  // set node in store
  setPlayerNode(node);
  setBarView('list');

  // scroll to node
  const item = getSidebarListDomItem(node.id);

  if (isMobile) {
    setTimeout(() => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }, 100);
  } else {
    setTimeout(() => {
      item?.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'start',
      });
    }, 200);

    window.scrollTo({
      top: 0,
      behavior: 'instant',
    });
  }

  // history
  if (playerNode?.id === node.id || idx < 0) return;

  router.navigate({
    // @ts-ignore
    search: (prev) => {
      return {
        ...prev,
        c: node.id,
      };
    },
    replace: false,
  });
};
